import axios from '@/libs/api.request'
// 获取所有标签
export const getIndustryLabel = (params) => {
    return axios.request({
        url: '/member/industry',
        method: 'post',
        data: params
    })
}

// 获取用户信息
export const getUserInfoData = (params) => {
    return axios.request({
        url: `/member/${params.id}`,
        method: 'post',
        data: params
    })
}

// 提交标签
export const updateTag = (params) => {
    return axios.request({
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        url: '/member/updateTag',
        method: 'post',
        data: params
    // transformRequest: [function (data) {
    //   // 对请求数据处理, 将数据转为表单数据
    //   data = Qs.stringify(data)
    //   console.log('打印下数据', data)
    //   return data
    // }]
    })
}
export const getBannerList = (params) => {
    return axios.request({
        url: `/banner?type=${params.type}`,
        method: 'get',
        // params: params
    })
}
export const getMenuVideo = (params) => {
    return axios.request({
        url: `/menu_bind?mark=${params.mark}&module=${params.module}&type=${params.type}&cid=0`,
        method: 'get',
        // data: params
    })
}
